import { FormComponent } from "../../../utils/enums";
import { mockInventory } from "../../../../api/pharmacy/mock-data/inventory";
import { MedicationInventory } from "../../../../interfaces/pharmacy";

const medicationOptions = mockInventory.map((item: MedicationInventory) => ({
  label: item.medicationName,
  value: item.medicationName,
}));

export 
const medicationFormSchema = {
  type: "object" as const,
  properties: {
    name: {
      label: "Medication",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        options: [], // Will be populated from props
        helperText: "Search and select medication",
      },
    },
    dosage: {
      label: "Dosage",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        type: "text",
        placeholder: "Enter dosage (e.g., 500mg)",
        helperText: "Specify the amount and unit",
      },
    },
    frequency: {
      label: "Frequency",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        type: "text",
        placeholder: "Enter frequency (e.g., twice daily)",
        helperText: "Specify how often to take the medication",
      },
    },
    startDate: {
      label: "Start Date",
      type: "date",
      required: true,
      component: FormComponent.DatePicker,
      componentProps: {
        showTime: false,
        helperText: "When to start taking the medication",
      },
    },
    notes: {
      label: "Notes",
      type: "textarea",
      required: false,
      component: FormComponent.Textarea,
      componentProps: {
        placeholder: "Enter any additional notes",
        helperText: "Optional notes about the medication",
      },
    },
  },
  required: ["medication", "dosage", "frequency", "startDate"],
};



